import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import { Label, Input, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.config.presupuesto.condiciones.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"La Moneda de Pago ha sido creada con éxito."}
                title={"Nueva Moneda de Pago"}
                buttonTitle={"Nueva Moneda de Pago"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la moneda</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_Condiciones/Create.js